/* angular:styles/component:css;0897f769ae5bf749;/home/runner/work/app/app/src/app/components/onboarding-tour/onboarding-tour.component.ts */
.tour {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 0.5rem 0 0.25rem;
}
.tour-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  min-height: 11rem;
  max-width: 28rem;
}
.tour-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 1rem;
  background: color-mix(in srgb, var(--primary-color, #6366f1) 12%, transparent);
  color: var(--primary-color, currentColor);
}
.tour-title {
  margin: 0.5rem 0 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.tour-explain {
  margin: 0;
  line-height: 1.55;
  color: var(--text-secondary-color, inherit);
}
.tour-dots {
  display: flex;
  gap: 0;
}
.tour-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.25rem;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  background: transparent;
}
.tour-dot::before {
  content: "";
  display: block;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 999px;
  background: var(--border-color, rgba(127, 127, 127, 0.35));
}
.tour-dot.active::before {
  width: 1.5rem;
  background: var(--primary-color, currentColor);
}
.tour-dot:focus-visible {
  outline: 2px solid var(--primary-color, currentColor);
  outline-offset: 0;
}
/*# sourceMappingURL=onboarding-tour.component-N32UFSJW.css.map */
